import { useAuthStore } from '../store/authStore';

/**
 * The signed-in account's email, or null.
 *
 * A one-function module rather than an import inside each passphrase screen,
 * for two reasons. `vaultPassphraseUtils.js` is deliberately pure — it may not
 * reach into a store — and `authStore` pulls in the whole API/socket/OIDC
 * graph, which the passphrase screens otherwise have no reason to know about.
 * One seam keeps that coupling visible and mockable.
 *
 * The value is sent to `vault_master_prepare` / `vault_master_change` for
 * exactly one purpose: Rust refuses a passphrase equal to the email's local
 * part (CONTRACT §5), which is the single most guessable choice the compiled
 * blocklist cannot contain. It is never stored, never logged, and read
 * non-reactively — a passphrase screen must not re-render because a profile
 * refresh landed.
 */
export function accountEmail() {
  try {
    return useAuthStore.getState()?.user?.email || null;
  } catch {
    return null;
  }
}
